// 必要なコンポーネントやフックをインポート
import { Box, Button, Modal, Stack, Typography, useMediaQuery } from "@mui/material"; // Material-UIのコンポーネント
import { useState } from "react"; // Reactの状態管理用フック

/**
 * Obj001コンポーネント
 * - ユーザーがコマンドを入力し、その結果をシミュレーションするコンポーネント
 * - 入力に基づいて応答を表示し、モーダルで正解・不正解を示す
 */
const Obj001 = () => {
    // 入力内容、状態、応答内容を管理するステート
    const [answer, setAnswer] = useState<string>(""); // ユーザーが入力したコマンド
    const [status, setStatus] = useState<number>(0); // コマンド実行の結果ステータス
    const [responce, setResponce] = useState<string[]>(["　", "　"]); // コマンド実行後の応答内容

    // 正解となるコマンドの正規表現
    const answer1 = /^\s*date\s+\/t\s*$/g;
    const answer2 = /^\s*time\s+\/t\s*$/g;
    const answer3 = /^\s*echo\s+%date%\s*$/g;
    const answer4 = /^\s*echo\s+%time%\s*$/g;
    const answer5 = /^\s*date\s*$/g;
    const answer6 = /^\s*time\s*$/g;

    // レスポンシブ対応のメディアクエリ
    const matches: boolean = useMediaQuery("(min-width:640px)");

    // モーダルの開閉状態を管理するステート
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    // モーダルのスタイル設定
    const style = {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: matches ? 470 : 320,
        bgcolor: 'background.paper',
        border: '1px solid #000',
        boxShadow: 24,
        p: 4,
    };

    // メインのUIを構築
    return (
        <Box bgcolor={'black'} marginY={"1rem"} padding={"1rem"} color={'white'} fontSize={16}>
            {/* コマンド入力欄 */}
            <Stack direction={"row"}>
                <Box>{`C:\\Users\\zealhollding>`}</Box>
                <input 
                    style={{
                        backgroundColor: "#000000", 
                        color: "#ffffff", 
                        outline: 'none', 
                        border: 'none', 
                        width: "8rem", 
                        fontSize: "16px"
                    }}
                    maxLength={80} // 最大入力文字数
                    onChange={(e) => {
                        setAnswer(e.target.value); // 入力値をステートに保存
                        setStatus(0); // ステータスをリセット
                        setResponce(["　", "　"]); // 応答内容をリセット
                    }}
                />
            </Stack>
            {/* コマンド実行後の応答を表示 */}
            <Box>{responce[0]}</Box>
            <Box>{responce[1]}</Box>
            <Box justifyContent="flex-end" display="flex">
                <Button
                    variant={answer?.length > 0 ? 'contained' : 'text'} // 入力がある場合にスタイルを変更
                    size={answer?.length > 0 ? 'large' : 'small'}
                    onClick={() => {
                        // 現在の日付・時刻を取得
                        const now = new Date();
                        const year = now.getFullYear().toString().padStart(4, '0');
                        const month = (now.getMonth() + 1).toString().padStart(2, '0');
                        const date = now.getDate().toString().padStart(2, '0');
                        const hours = now.getHours().toString().padStart(2, '0');
                        const minutes = now.getMinutes().toString().padStart(2, '0');
                        const seconds = now.getSeconds().toString().padStart(2, '0');
                        const milliseconds = now.getMilliseconds().toString().substring(0, 2).padStart(2, '0');
                        
                        // 入力に応じた処理を実行
                        if (!answer || answer === "") {
                            setStatus(0);
                            setResponce(["　", "　"]);
                        } else if (answer.toLocaleLowerCase().match(answer1)) {
                            setStatus(1);
                            setResponce([`${year}/${month}/${date}`, "　"]);
                        } else if (answer.toLocaleLowerCase().match(answer2)) {
                            setStatus(2);
                            setResponce([`${hours}:${minutes}`, "　"]);
                        } else if (answer.toLocaleLowerCase().match(answer3)) {
                            setStatus(3);
                            setResponce([`${year}/${month}/${date}`, "　"]);
                        } else if (answer.toLocaleLowerCase().match(answer4)) {
                            setStatus(4);
                            setResponce([`${hours}:${minutes}:${seconds}.${milliseconds}`, "　"]);
                        } else if (answer.toLocaleLowerCase().match(answer5)) {
                            setStatus(5);
                            setResponce([`現在の日付: ${year}/${month}/${date}`, "新しい日付を入力してください: (年-月-日)"]);
                        } else if (answer.toLocaleLowerCase().match(answer6)) {
                            setStatus(6);
                            setResponce([`現在の時刻: ${hours}:${minutes}:${seconds}.${milliseconds}`, "新しい時刻を入力してください:"]);
                        } else {
                            setStatus(-1);
                            setResponce([`'${answer}' は、内部コマンドまたは外部コマンド、`, "操作可能なプログラムまたはバッチ ファイルとして認識されていません。"]);
                        }

                        if (answer && answer !== "") {
                            handleOpen(); // モーダルを開く
                        }
                    }}
                >
                    {answer?.length > 0 ? "実 行" : "実行"}
                </Button>
            </Box>
            {/* 結果を表示するモーダル */}
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
            <Box sx={style}>
                <Typography 
                    id="modal-modal-title" 
                    variant="h6" 
                    component="h2" 
                    color={(status > 0 && status < 5) ? "red" : "grey"}
                >
                    {(status > 0 && status < 5) ? "正解" : "不正解"}
                </Typography>
                <Typography sx={{ mt: 2 }}>
                    {(status === 1 || status === 3) 
                        ? "date /Tで表示できた方は、echoコマンドでも同じ表示ができます。"
                        : (status === 2 || status === 4) 
                            ? "time /Tで表示できた方は、echoコマンドでも同じ表示ができます。"
                            : "日付を表示するコマンドは「date」で、時間を意味するオプションを追加してみましょう。"
                    }
                </Typography>
                {(status > 0 && status < 5) && <Typography>未経験者で最初からechoを使用して表示できた方は、とても素晴らしいです！</Typography>}
            </Box>
            </Modal>
        </Box>
    );
}

/**
 * EMObjectコンポーネント
 * - 指定されたIDに基づいて適切なオブジェクトコンポーネントをレンダリング
 */
const EMObject = ({ oId }: { oId: number }) => {
    const obj = [<Obj001 />][oId - 1]; // IDに基づいて対応するコンポーネントを取得
    return (
        <>{obj}</>
    );
}

// EMObjectコンポーネントをデフォルトエクスポート
export default EMObject;
